import * as React from 'react';

import { IconButton } from '@mui/material';

import AddIcon from '@mui/icons-material/PlaylistAdd';
import RemoveIcon from '@mui/icons-material/PlaylistRemove';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

import { DraggableAttributes, UniqueIdentifier } from '@dnd-kit/core';
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';

import { useUnattachedEventReportsSelectionData } from '../../core/context/UnattachedEventReportsSelectionContext';
import { useUnattachedEventReportsData, INDIVIDUAL_REPORTS_COLLECTION_ID } from '../../core/context/UnattachedEventReportsContext';

interface SortableEventReportActionButtonProps {
  eventReportId: number | undefined;
  parentContainerId: UniqueIdentifier | null;
  draggableAttributes?: DraggableAttributes;
  draggableListeners?: SyntheticListenerMap | undefined;
}

function SortableEventReportActionButton({
  eventReportId,
  parentContainerId,
  draggableAttributes,
  draggableListeners,
}: SortableEventReportActionButtonProps) {
  const { checkedContainer } = useUnattachedEventReportsSelectionData();
  const { moveReport, isLargeDataSet } = useUnattachedEventReportsData();

  const handleIconButtonClick = (): void => {
    if (eventReportId !== undefined && parentContainerId !== null && checkedContainer !== null) {
      const toContainerId: UniqueIdentifier = checkedContainer === parentContainerId
        ? INDIVIDUAL_REPORTS_COLLECTION_ID
        : checkedContainer;

      moveReport(eventReportId, parentContainerId, toContainerId, undefined);
    }
  };

  if (checkedContainer === null && !isLargeDataSet) {
    return (
      <IconButton {...draggableAttributes} {...draggableListeners}>
        <DragIndicatorIcon />
      </IconButton>
    );
  }

  if (checkedContainer) {
    return (
      <IconButton onClick={handleIconButtonClick}>
        {checkedContainer === parentContainerId ? <RemoveIcon /> : <AddIcon />}
      </IconButton>
    );
  }

  return null;
}

export default SortableEventReportActionButton;
